<script>
import get from 'lodash/get';
import isEqual from 'lodash/isEqual';
import vueMixins from 'viralstyle-ui/src/vueMixins';
import VsButton from 'viralstyle-ui/src/VsButton';
import VsButtonToggle from 'viralstyle-ui/src/VsButtonToggle';
import VsInput from 'viralstyle-ui/src/VsInput';
import VsLayout from 'viralstyle-ui/src/VsLayout';
import { mapState } from 'vuex';

import { paymentAchValidator } from '../_settings-validator';

export default {
  components: {
    VsInput,
    VsButton,
    VsButtonToggle,
    VsLayout,
  },
  mixins: [vueMixins],
  props: {
    hideSubmit: [Boolean, String],
  },
  data: () => ({
    paymentAchValidator,
    accountTypes: [{ text: 'Checking', value: 'CHECKING' }, { text: 'Savings', value: 'SAVINGS' }],
    accountClientTypes: [{ text: 'Personal', value: 'PERSONAL' }, { text: 'Business', value: 'BUSINESS' }],
  }),
  computed: mapState({
    processing: state => state.processing,
    paymentInfo: state => state.settings.paymentInfo,
    paymentInfoSubmitted: state => state.settings.paymentInfoSubmitted,
    originalPaymentInfo: state => state.settings.originalPaymentInfo,
  }),
  created() {
    paymentAchValidator.clear();
    if (this.originalPaymentInfo && !isEqual(this.paymentInfo.ach_details, this.originalPaymentInfo.ach_details)) {
      this.$store.commit('updateStateClone', { object: this.paymentInfo, property: 'ach_details', value: this.originalPaymentInfo.ach_details });
    }
  },
  updated() {
    this.$emit('update');
  },
  methods: {
    updatePaymentInfo(e, prop) {
      let value = get(e, 'target.value') !== undefined ? get(e, 'target.value') : e;
      this.$store.commit('updatePaymentInfo', { prop: `ach_details.${prop}`, value })
      paymentAchValidator.validate(prop, value);
    },
    async savePaymentMethod() {
      let valid = await paymentAchValidator.validateAll(this.paymentInfo.ach_details);
      if (valid) {
        this.$store.dispatch('savePaymentMethod', 'ACH');
        this.$store.commit('updateState', { object: this.paymentInfoSubmitted, property: 'ACH', value: false });
      } else {
        this.$store.commit('updateState', { object: this.paymentInfoSubmitted, property: 'ACH', value: true });
      }
    },
  },
};
</script>

<template lang='pug'>
.accordion-content__client
  vs-input(
    full-width,
    prevent-autofill,
    type='text',
    placeholder='Full Name',
    :value='get(paymentInfo, "ach_details.name")',
    :error='paymentInfoSubmitted.ACH && paymentAchValidator.hasError("name")',
    @input='updatePaymentInfo($event, "name")',
  )
  .vs-error(v-show='paymentInfoSubmitted.ACH && paymentAchValidator.hasError("name")') {{paymentAchValidator.firstError('name')}}

  vs-input(
    full-width,
    prevent-autofill,
    type='text',
    placeholder='Bank Name',
    :value='get(paymentInfo, "ach_details.bank")',
    :error='paymentInfoSubmitted.ACH && paymentAchValidator.hasError("bank")',
    @input='updatePaymentInfo($event, "bank")',
  )
  .vs-error(v-show='paymentInfoSubmitted.ACH && paymentAchValidator.hasError("bank")') {{paymentAchValidator.firstError('bank')}}

  vs-button-toggle(
    :options='accountTypes',
    :selected-option='get(paymentInfo, "ach_details.type")',
    @toggle='updatePaymentInfo($event, "type")',
  )

  vs-button-toggle(
    :options='accountClientTypes',
    :selected-option='get(paymentInfo, "ach_details.type2")',
    @toggle='updatePaymentInfo($event, "type2")',
  )

  vs-input(
    full-width,
    prevent-autofill,
    type='text',
    placeholder='Routing Number',
    :error='paymentInfoSubmitted.ACH && paymentAchValidator.hasError("routing")',
    :value='get(paymentInfo, "ach_details.routing")',
    @input='updatePaymentInfo($event, "routing")',
  )
  .vs-error(v-show='paymentInfoSubmitted.ACH && paymentAchValidator.hasError("routing")') {{paymentAchValidator.firstError('routing')}}

  vs-input(
    full-width,
    prevent-autofill,
    type='text',
    placeholder='Account Number',
    :value='get(paymentInfo, "ach_details.account")',
    :error='paymentInfoSubmitted.ACH && paymentAchValidator.hasError("account")',
    @input='updatePaymentInfo($event, "account")',
  )
  .vs-error(v-show='paymentInfoSubmitted.ACH && paymentAchValidator.hasError("account")') {{paymentAchValidator.firstError('account')}}

  vs-button(
    v-if='!hideSubmit',
    text='save',
    icon='content-save',
    :processing='processing',
    :disabled='processing',
    @click='savePaymentMethod',
  )
</template>